const userRoles = ['Admin', '主管', '工人'];
const userStatus = ['在職', '離職'];
const shiftLable = ['上午', '下午', '加班'];

export { userRoles, userStatus, shiftLable };



// WEBPACK FOOTER //
// ./src/common/state_mapping.js